import * as SC from './AnimationStyles';

type AnimationProps = {
  animationData: unknown;
};

export const Animation = ({ animationData }: AnimationProps) => {
  return (
    <SC.AnimationContainer>
      <SC.LottieStyled animationData={animationData} loop={false} />
    </SC.AnimationContainer>
  );
};
